// extracted by mini-css-extract-plugin
export default {"product":"checkout-product_product__v0Qnx","img":"checkout-product_img__y0nv+","text":"checkout-product_text__7nWvx","leftbox":"checkout-product_leftbox__UDk7E"};